import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-uiform-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent implements OnChanges {
  constructor(private router: Router) {}

  @Input() uiformId: number | null = 0;
  @Input() targetId: any;
  @Input() appId: any;
  @Input() usecaseId: any;
  @Input() effectiveFormId: any;

  routerLinkPath: any[] = [];  

  ngOnChanges(changes: SimpleChanges) {
    this. getRouterLink(); 
  }

  goBack() {
    if (this.usecaseId) {
      this.router.navigate(['/uiformcreate', this.usecaseId]);
    }
  }

  getClass(active: any) {
    return this.targetId === active
      ? 'nav-link active btn-link bg-secondary'
      : 'nav-link btn-link text-secondary';
  }

  getAiIcon(active: string) {
    const isActive = this.targetId === active;
    const isDark = document.documentElement.classList.contains('dark-theme');

    if (isDark) {
      return isActive
        ? 'assets/images/icons/ai-white.png' // active in dark
        : 'assets/images/icons/ai-white.png'; // inactive in dark (usually white for visibility)
    }

    // light theme
    return isActive
      ? 'assets/images/icons/ai-white.png' // active in light
      : 'assets/images/icons/ai-black.png'; // inactive in light
  }
 
  private  getRouterLink() { 
  const baseId = this.uiformId ?? 0;
  const effId = this.effectiveFormId ?? baseId;
  if (baseId === effId) {
    this.routerLinkPath = ['/uiform', baseId];
    } else {
    this.routerLinkPath = ['/uiform', baseId, effId];
    }
  if (this.effectiveFormId && baseId !== effId) {
    this.router.navigate(this.routerLinkPath);
  }
}
}
